import React, { useState, useEffect } from 'react';

import './Resources/css/site.css';
import './Resources/css/site_imageInsert.css';
import './Resources/css/site_navbar.css';

import AppWrapper from '../../Controls/Scafolding/AppWrapper';
import { NavMenu } from '../../Controls/NavMenu';

import Top from './Blocks/Top';
import AboutUs from './Blocks/AboutUs';
import ImageInsert from '../../Controls/Digital/ImageInsert';
import TheSecret from './Blocks/TheSecret';
import Wholesale from './Blocks/Wholesale'
import FoodMenu from './Blocks/FoodMenu'
import ContactUs from './Blocks/ContactUs';
import Catering from './Blocks/Catering';
import Footer from './Blocks/Footer';

const Bakery = (props) => {

    let logoIconPath = require("./Resources/Images/logo.png");

    const [menu] = useState({
        hasLogo: false,
        logoUrl: logoIconPath,
        styles: {},

        text: '',
        textSmallDisplay: 'Gwynneville Bakery',
        icon: "",

        hasMessage : true,
        messageLeft : '',

        items: [
            { linkLabel: 'Home', linkUrl: '#top' },
            { linkLabel: 'Our Story', linkUrl: '#aboutUs' },
            { linkLabel: 'The Team', linkUrl: '#theSecret' },
            { linkLabel: 'Catering', linkUrl: '#catering' },
            { linkLabel: 'Wholesale', linkUrl: '#wholesale' },
            { linkLabel: 'Menu', linkUrl: '#foodmenu' },
            { linkLabel: 'Contact', linkUrl: '#contactUs2' },
        ]
    });

    useEffect(() => {
    });

    return (
        <AppWrapper wrapClass="gbk">
            <NavMenu menu={menu} offset="50" addClass="Menu sticky-top" />

            <Top />
            <AboutUs />
            <ImageInsert addClass="insert1" />
            <TheSecret />
            <Catering />
            <ImageInsert addClass="insert2" />
            <Wholesale />
            <FoodMenu />
            <ImageInsert addClass="insert3" />
            <ContactUs />
            <Footer />
        </AppWrapper>
    );
}
export default Bakery;

